














import { defineComponent, computed } from "@vue/composition-api";
import Infoland3ColContainer from "@/components/generic/infoland-3col-container.vue";
import SearchComponent from "@/components/generic/SearchComponent.vue";
import { useScroll } from "@/composables/useScroll";
import Shared from "@/shared";

export default defineComponent({
    name: "AiSearchBar",
    props: {
        searchText: String
    },
    components: {
        Infoland3ColContainer,
        SearchComponent
    },
    setup(_, { emit }) {
        /**
         * The direction of the scroll needed for UI animations
         */
        const { direction: scrollDirection } = useScroll({ directionChangeTreshold: 36 });
        const isScrollingUp = computed(() => scrollDirection.value === "up");

        // Emit the search event only if the search query is valid
        const onSearch = (searchQuery: string) => {
            const regex = /[\p{L}\d\.\-]*[\p{L}\d]/u; // Match any letter, digit or dot
            const isValidQuery = regex.test(searchQuery);
            if (!isValidQuery) {
                return;
            }
            emit("search", searchQuery);
        };

        return {
            isScrollingUp,
            onSearch
        };
    },
    computed: {
        baseUrl(): string {
            return Shared.iProvaUrl;
        },
        smAndDown(): boolean {
            return this.$vuetify.breakpoint.smAndDown;
        }
    }
});
